import videojs from 'video.js'
import NFBHLSQualitySelector from '../plugins/NFBHLSQualitySelector.js'

const MenuItem = videojs.getComponent('MenuItem')

/**
 * Extend vjs menu item class.
 */
export default class NFBHLSQualityItem extends MenuItem {

  /**
   * Menu item constructor.
   *
   * @param {Player} player - vjs player
   * @param {Object} item - Item object
   * @param {Array} levelItems - Quality list
   * @param {NFBHLSQualitySelector} plugin - NFBHLSQualitySelector
   */
  constructor(player, item, levelItems, plugin) {
    super(player, {
      label: item.label,
      selectable: true,
      selected: item.selected || false
    });

    this.item = item
    this.addClass('nfb-settings-panel__item')
    this.setAttribute('tabindex', '0')

    this.levelItems = levelItems
    this.plugin = plugin

    player.one('sourcechanged', () => {
      this.dispose()
    })
  }

  handleClick() {
    // Reset other menu items selected status.
    this.levelItems.forEach(levelItem => levelItem.selected(false))

    // Set this menu item to selected, and set quality.
    this.plugin.setQuality(this.item.value)
    this.selected(true)
  }
}
